export const presentationLocale = language => (language === 'en' ? 'en-GB' : 'pl-PL');

export const monthNames = language => Array.from({ length: 12 }, (_, month) => (
  new Intl.DateTimeFormat(presentationLocale(language), { month: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2026, month, 1)))
));

export const weekdayNames = language => (language === 'en'
  ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  : ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd']);

export const weekdayName = (id, language) => {
  const day = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].indexOf(id);
  if (day < 0) return '';
  const label = new Intl.DateTimeFormat(presentationLocale(language), { weekday: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2026, 8, 21 + day)));
  return label.charAt(0).toUpperCase() + label.slice(1);
};
